export default "__VITE_ASSET__Dd48H9KB__"